import {
    COVERAGE_DETAIL_INFO_OPEN_MODAL
} from 'Redux/actionTypes';

export const coverageDetailInfoOpenModal = (details) => ({
    type: COVERAGE_DETAIL_INFO_OPEN_MODAL,
    payload: { details }
})